import {NameRuler} from '@dofleini/validator';

export const fields = [
  {
    key: 'name',
    label: 'name',
    required: true, // this adds an entry to rules: [{ required: true, message: 'Username is required' }]
    rules: [
      NameRuler
    ]
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    onlyView: true,
  },
  {

    key: 'description',
    label: 'description',
    widget: 'textarea',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    required: true,
    className: 'form-view-mode-vertical-item'
  },
];
